import termsGeneral from '@/store/modules/terms/general';

export default {
  termsGeneral,
};
